/** "29.95", "$1,299", "1299.5" → cents; null when it isn't an amount. */
export function toCents(text: string): number | null {
  const t = text.replace(/[$,\s]/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null;
  const [d, c = ""] = t.split(".");
  return Number(d) * 100 + Number((c + "00").slice(0, 2));
}

/** Cents → the plain number a money input shows ("29.95", "99"). */
export function centsToInput(cents: number | null | undefined): string {
  if (cents == null) return "";
  return cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
}
